export var SET_VOTE_WINNER = "SET_VOTE_WINNER";
export function setVoteWinner(val) {
    return function (dispatch) {
        dispatch({
            type: SET_VOTE_WINNER,
            payload: val,
        });
    };
}
//# sourceMappingURL=setVoteWinner.js.mapexport var SET_VOTE_WINNER = "SET_VOTE_WINNER";
export function setVoteWinner(val) {
    return function (dispatch) {
        dispatch({
            type: SET_VOTE_WINNER,
            payload: val,
        });
    };
}
//# sourceMappingURL=setVoteWinner.js.map